import { withSpinner } from 'src/common/components/with-spinner/with-spinner';
import { ItemNotFound } from 'src/common/helpers/error-code';
import { store } from 'src/common/redux/configure-store';
import { BRMInputActions } from 'src/common/redux/reducers/brm-input-reducer';
import { handleItemNotFound } from '../../item-not-found/business-logic/handle-item-not-found';
import { handleLinkedItemGroup } from '../../linked-item/handle-linked-item';
import { lineItemAdd } from './line-item-add';
import { IItemBuiltQuery, queryAndBuildLineItem } from './query-and-build-line-item';

export const addLookupLineItem = async (itemQuery: IItemBuiltQuery): Promise<void> => {
  return queryAndBuildLineItem(itemQuery)
    .then(itemAddData =>
      withSpinner(async () => {
        if (itemAddData.itemLookup.linkedItemsGroup) {
          return handleLinkedItemGroup(itemAddData);
        }
        return lineItemAdd(itemAddData);
      }),
    )
    .catch(err => {
      if (err.code === ItemNotFound) {
        return handleItemNotFound(itemQuery.inputData);
      } else {
        throw err;
      }
    })
    .finally(() => {
      store.dispatch(BRMInputActions.resetState());
    });
};
